import { useEffect } from 'react';

import { CommandBarAggregatorContext, useCommandBarAggregator } from './command-bar-context.js';
import { useCommandBarStore } from './command-bar-store.js';

import type { ReactNode } from 'react';

interface CommandBarProviderProps {
	children: ReactNode;
}

/**
 * Provider component that enables the command bar system.
 * Must wrap any components that want to register command bar providers.
 *
 * Should be placed near the root of the application (e.g., in RootLayout).
 */
export function CommandBarProvider({ children }: CommandBarProviderProps) {
	const aggregator = useCommandBarAggregator();

	// Set up global keyboard shortcut (Cmd+K / Ctrl+K)
	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
				e.preventDefault();
				useCommandBarStore.getState().toggle();
			}
		};

		document.addEventListener('keydown', handleKeyDown);
		return () => document.removeEventListener('keydown', handleKeyDown);
	}, []);

	return <CommandBarAggregatorContext.Provider value={aggregator}>{children}</CommandBarAggregatorContext.Provider>;
}
